<template>
  <a rel="nofollow, noindex" data-lightbox="images" :href="photo.lgUrl" class="square thumnbail mr-2" style="max-width: 30%; width:100px; height:100px;">
    <img loading="lazy" decoding="async" :alt="title" :title="title" class="rounded-lg mr-2 square" :src="photo.smUrl">
  </a>
</template>

<script>

export default {
  props: {
    photo: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    fetchUnprocessed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
